import React, { useEffect, useMemo } from "react";

// components
import Authorization from "../components/DSPIntegration/Authorization";
import LocationsAndMenu from "../components/DSPIntegration/LocationsAndMenu";

// third party
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import { Redirect } from "react-router-dom";

// actions
import { fetchDspPlatformsList } from "../actions/dspIntegration";

const DSPIntegration = ({ match, dspIntegration, dspPlatformsList, editMode = false }) => {
	const { search } = useLocation();
	const query = useMemo(() => new URLSearchParams(search), [search]);
	const { isDSPIntegrated, isValidDSP } = dspIntegration;
	const { isLoading } = dspPlatformsList;

	useEffect(() => {
		if (!dspPlatformsList?.objects?.length) {
			fetchDspPlatformsList(match?.params?.dsp);
		}
	}, []);

	// redirect back to integrations page if dsp is not a valid platform of dspPlatformList api
	if (!isValidDSP && !isLoading) {
		return <Redirect to="/hub/integrations" />;
	}

	// if dsp is not integrated (access not granted) proceed to authorization workflow
	if (!isDSPIntegrated) {
		return (
			<div className="dsp-integration-container section-container-common">
				<Authorization dsp={match?.params?.dsp} isLoading={isLoading} />
			</div>
		);
	}

	// if dsp is integrated, show locations and menu associations in a list view
	return (
		<div className="dsp-integration-container section-container-common">
			<LocationsAndMenu match={match} editMode={editMode} />
		</div>
	);
};
const mapStateToProps = (store) => ({
	dspPlatformsList: store.dspPlatformsList,
	dspIntegration: store.dspIntegration
});
export default connect(mapStateToProps)(DSPIntegration);
